webpackJsonp([129448336650289],{

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Divider = __webpack_require__(47);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _IconGridModule = __webpack_require__(205);
	
	var _IconGridModule2 = _interopRequireDefault(_IconGridModule);
	
	var _Inner = __webpack_require__(48);
	
	var _Inner2 = _interopRequireDefault(_Inner);
	
	var _handshake = __webpack_require__(96);
	
	var _handshake2 = _interopRequireDefault(_handshake);
	
	var _backup = __webpack_require__(90);
	
	var _backup2 = _interopRequireDefault(_backup);
	
	var _consulting = __webpack_require__(92);
	
	var _consulting2 = _interopRequireDefault(_consulting);
	
	var _disasterRecovery = __webpack_require__(93);
	
	var _disasterRecovery2 = _interopRequireDefault(_disasterRecovery);
	
	var _networking = __webpack_require__(97);
	
	var _networking2 = _interopRequireDefault(_networking);
	
	var _globe = __webpack_require__(95);
	
	var _globe2 = _interopRequireDefault(_globe);
	
	var _firewall = __webpack_require__(94);
	
	var _firewall2 = _interopRequireDefault(_firewall);
	
	var _server = __webpack_require__(98);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _audit = __webpack_require__(89);
	
	var _audit2 = _interopRequireDefault(_audit);
	
	var _virtualization = __webpack_require__(99);
	
	var _virtualization2 = _interopRequireDefault(_virtualization);
	
	var _consolidation = __webpack_require__(91);
	
	var _consolidation2 = _interopRequireDefault(_consolidation);
	
	var _workstations = __webpack_require__(103);
	
	var _workstations2 = _interopRequireDefault(_workstations);
	
	var _dataRecovery = __webpack_require__(100);
	
	var _dataRecovery2 = _interopRequireDefault(_dataRecovery);
	
	var _secureDataDelete = __webpack_require__(102);
	
	var _secureDataDelete2 = _interopRequireDefault(_secureDataDelete);
	
	var _ransom = __webpack_require__(101);
	
	var _ransom2 = _interopRequireDefault(_ransom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconGrid = function IconGrid(props) {
	  var icons = props.items.map(function (item) {
	    function theIcon(item) {
	      var rawIcon = item.node.childMarkdownRemark.frontmatter.icon;
	      if (rawIcon == '/assets/secure-data-delete.svg') {
	        return _react2.default.createElement(_secureDataDelete2.default, null);
	      }
	      if (rawIcon == '/assets/data-recovery.svg') {
	        return _react2.default.createElement(_dataRecovery2.default, null);
	      }
	      if (rawIcon == '/assets/handshake.svg') {
	        return _react2.default.createElement(_handshake2.default, null);
	      }
	      if (rawIcon == '/assets/backup.svg') {
	        return _react2.default.createElement(_backup2.default, null);
	      }
	      if (rawIcon == '/assets/consulting.svg') {
	        return _react2.default.createElement(_consulting2.default, null);
	      }
	      if (rawIcon == '/assets/disaster-recovery.svg') {
	        return _react2.default.createElement(_disasterRecovery2.default, null);
	      }
	      if (rawIcon == '/assets/networking5.svg') {
	        return _react2.default.createElement(_networking2.default, null);
	      }
	      if (rawIcon == '/assets/globe.svg') {
	        return _react2.default.createElement(_globe2.default, null);
	      }
	      if (rawIcon == '/assets/firewall.svg') {
	        return _react2.default.createElement(_firewall2.default, null);
	      }
	      if (rawIcon == '/assets/server.svg') {
	        return _react2.default.createElement(_server2.default, null);
	      }
	      if (rawIcon == '/assets/audit2.svg') {
	        return _react2.default.createElement(_audit2.default, null);
	      }
	      if (rawIcon == '/assets/virtualization.svg') {
	        return _react2.default.createElement(_virtualization2.default, null);
	      }
	      if (rawIcon == '/assets/consolidation.svg') {
	        return _react2.default.createElement(_consolidation2.default, null);
	      }
	      if (rawIcon == '/assets/workstations.svg') {
	        return _react2.default.createElement(_workstations2.default, null);
	      }
	      if (rawIcon == '/assets/ransom.svg') {
	        return _react2.default.createElement(_ransom2.default, null);
	      }
	    }
	    return _react2.default.createElement(
	      'li',
	      { key: item.node.id },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/solutions' + item.node.childMarkdownRemark.fields.slug },
	        theIcon(item),
	        _react2.default.createElement(
	          'h2',
	          { className: _IconGridModule2.default.itemHeading },
	          item.node.childMarkdownRemark.frontmatter.title
	        )
	      )
	    );
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: _IconGridModule2.default.wrapper },
	    _react2.default.createElement(
	      _Inner2.default,
	      null,
	      _react2.default.createElement(
	        'h1',
	        { className: _IconGridModule2.default.heading },
	        props.heading
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: _IconGridModule2.default.items },
	        icons
	      )
	    )
	  );
	};
	
	exports.default = IconGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 205:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"bp":"(min-width: 700px)","darkGradient":"radial-gradient(#002A3B 0%, #00171F 94.96%)","dark":"#00171F","black":"#000000","tblue":"undefined","gray":"#EFEFEF","blue":"#00A8E8","wrapper":"src-components-IconGrid----IconGrid-module---wrapper---2T1A6","heading":"src-components-IconGrid----IconGrid-module---heading---1Y62o","itemHeading":"src-components-IconGrid----IconGrid-module---itemHeading---HmDmd","items":"src-components-IconGrid----IconGrid-module---items---Cr34w"};

/***/ }),

/***/ 639:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"bp":"(min-width: 700px)","gray":"#EFEFEF","black":"#000000","wrapper":"src-pages----SolutionsPage-module---wrapper---1rGqI"};

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(54);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PageWrapper = __webpack_require__(56);
	
	var _PageWrapper2 = _interopRequireDefault(_PageWrapper);
	
	var _IconGrid = __webpack_require__(154);
	
	var _IconGrid2 = _interopRequireDefault(_IconGrid);
	
	var _SolutionsPageModule = __webpack_require__(639);
	
	var _SolutionsPageModule2 = _interopRequireDefault(_SolutionsPageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SolutionsPage = function SolutionsPage(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _SolutionsPageModule2.default.wrapper },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Solutions - Dominion Systems, LLC',
	      meta: [{
	        name: 'description',
	        content: 'Backup & Restoration, Consulting, Workstations, Servers, Disaster Recovery and more.'
	      }]
	    }),
	    _react2.default.createElement(_IconGrid2.default, { heading: 'Our Solutions', items: props.data.solutions.edges })
	  );
	};
	
	exports.default = SolutionsPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Audit(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M208 132h288c8.8 0 16-7.2 16-16V76c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16zm0 160h288c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16zm0 160h288c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16zM64 368c-26.5 0-48.6 21.5-48.6 48s22.1 48 48.6 48 48-21.5 48-48-21.5-48-48-48zm92.5-299l-72.2 72.2-15.6 15.6c-4.7 4.7-12.9 4.7-17.6 0L3.5 109.4c-4.7-4.7-4.7-12.3 0-17l15.7-15.7c4.7-4.7 12.3-4.7 17 0l22.7 22.1 63.7-63.3c4.7-4.7 12.3-4.7 17 0l17 16.5c4.6 4.7 4.6 12.3-.1 17zm0 159.6l-72.2 72.2-15.7 15.7c-4.7 4.7-12.9 4.7-17.6 0L3.5 269c-4.7-4.7-4.7-12.3 0-17l15.7-15.7c4.7-4.7 12.3-4.7 17 0l22.7 22.1 63.7-63.7c4.7-4.7 12.3-4.7 17 0l17 17c4.6 4.6 4.6 12.2-.1 16.9z" }));
	}
	
	Audit.defaultProps = { "viewBox": "0 0 512 512" };
	
	module.exports = Audit;
	
	Audit.default = Audit;

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Backup(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z" }));
	}
	
	Backup.defaultProps = { "viewBox": "0 0 512 512" };
	
	module.exports = Backup;
	
	Backup.default = Backup;

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Consolidation(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M440.935 12.574l3.966 82.766C399.416 41.904 331.674 8 256 8 134.813 8 33.933 94.924 12.296 209.824 10.908 217.193 16.604 224 24.103 224h49.084c5.57 0 10.377-3.842 11.676-9.259C103.407 137.408 172.931 80 256 80c60.893 0 114.512 30.856 146.104 77.801l-101.53-4.865c-6.845-.328-12.574 5.133-12.574 11.986v47.411c0 6.627 5.373 12 12 12h200.333c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12h-47.411c-6.853 0-12.315 5.729-11.987 12.574zM256 432c-60.895 0-114.517-30.858-146.109-77.805l101.868 4.871c6.845.327 12.573-5.134 12.573-11.986v-47.412c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12V500c0 6.627 5.373 12 12 12h47.385c6.863 0 12.328-5.745 11.985-12.599l-4.129-82.575C112.725 470.166 180.405 504 256 504c121.187 0 222.067-86.924 243.704-201.824 1.388-7.369-4.308-14.176-11.807-14.176h-49.084c-5.57 0-10.377 3.842-11.676 9.259C408.593 374.592 339.069 432 256 432z" }));
	}
	
	Consolidation.defaultProps = { "viewBox": "0 0 512.333 512" };
	
	module.exports = Consolidation;
	
	Consolidation.default = Consolidation;

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Consulting(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z" }));
	}
	
	Consulting.defaultProps = { "viewBox": "0 0 384 512" };
	
	module.exports = Consulting;
	
	Consulting.default = Consulting;

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Workstations(props) {
	    return React.createElement("svg", props, [React.createElement("g", { "clipPath": "url(#clip0_472_658)", "key": 0 }, [React.createElement("path", { "d": "M262.942 39.7605L268.654 33.5968C275.79 25.9087 275.79 13.4542 268.654 5.76603C261.519 -1.92201 249.959 -1.92201 242.823 5.76603L206.289 45.129C199.154 52.8171 199.154 65.2716 206.289 72.9598L242.823 112.323C246.395 116.167 251.068 118.091 255.741 118.091C260.414 118.091 265.086 116.167 268.654 112.323C275.79 104.635 275.79 92.1802 268.654 84.492L264.153 79.6419C300.45 84.2065 328.809 117.142 328.809 157.455C328.809 200.872 296.037 236.181 255.74 236.181C215.45 236.181 182.672 200.872 182.672 157.455C182.672 146.577 174.493 137.773 164.405 137.773C154.317 137.773 146.138 146.577 146.138 157.455C146.138 222.575 195.3 275.544 255.74 275.544C316.18 275.544 365.343 222.575 365.343 157.455C365.343 94.9575 320.017 43.7856 262.941 39.7593L262.942 39.7605Z", "fill": "black", "key": 0 }), React.createElement("path", { "d": "M493.211 393.632H0V472.376C0 494.078 16.3871 511.721 36.5258 511.721H474.957C495.095 511.721 511.482 494.077 511.482 472.376V393.632H493.211ZM73.6111 472.358C63.5234 472.358 55.2543 463.554 55.2543 452.676C55.2543 441.799 63.344 432.995 73.4316 432.995H73.611C83.7068 432.995 91.878 441.799 91.878 452.676C91.878 463.554 83.7069 472.358 73.6111 472.358ZM182.671 472.358H127.87C117.782 472.358 109.602 463.554 109.602 452.676C109.602 441.799 117.782 432.995 127.87 432.995H182.671C192.758 432.995 200.938 441.799 200.938 452.676C200.938 463.554 192.758 472.358 182.671 472.358Z", "fill": "black", "key": 1 }), React.createElement("path", { "d": "M436.468 227.373C433.378 220.709 427.049 216.496 420.13 216.496H371.087C350.512 262.958 306.606 295.222 255.733 295.222C204.854 295.222 160.956 262.958 140.379 216.496H91.3312C84.4117 216.496 78.0839 220.709 74.9889 227.378L6.96863 373.943H504.501L436.468 227.373Z", "fill": "black", "key": 2 })]), React.createElement("defs", { "key": 1 }, React.createElement("clipPath", { "id": "clip0_472_658" }, React.createElement("rect", { "width": "512", "height": "512", "fill": "white" })))]);
	}
	
	Workstations.defaultProps = { "width": "512", "height": "512", "viewBox": "0 0 512 512", "fill": "none" };
	
	module.exports = Workstations;
	
	Workstations.default = Workstations;

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Disaster(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z" }));
	}
	
	Disaster.defaultProps = { "viewBox": "0 0 448 512" };
	
	module.exports = Disaster;
	
	Disaster.default = Disaster;

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Firewall(props) {
	    return React.createElement("svg", props, [React.createElement("rect", { "id": "Artboard1", "x": "0", "y": "0", "width": "60.775", "height": "46.3", "style": { "fill": "none" }, "key": 0 }), React.createElement("clipPath", { "id": "_clip1", "key": 1 }, React.createElement("rect", { "x": "0", "y": "0", "width": "60.775", "height": "46.3" })), React.createElement("g", { "clipPath": "url(#_clip1)", "key": 2 }, React.createElement("g", null, [React.createElement("g", { "key": 0 }, [React.createElement("path", { "d": "M7,47.2c-1.8,0 -3.5,0 -5.3,0c-0.8,0 -1.1,-0.4 -1.1,-1.5c0,-1.2 0,-2.4 0,-3.6c0,-1.1 0.3,-1.5 1.1,-1.5c3.5,0 7.1,0 10.6,0c0.8,0 1.1,0.4 1.1,1.5c0,1.2 0,2.4 0,3.6c0,1 -0.3,1.5 -1.1,1.5c-1.7,0 -3.5,0 -5.3,0Z", "style": { "fillRule": "nonzero" }, "key": 0 }), React.createElement("path", { "d": "M31.4,47.2l-14.1,0c-1.1,0 -1.5,-0.4 -1.5,-1.5c0,-1.2 0,-2.4 0,-3.7c0,-1 0.4,-1.5 1.6,-1.5c2.7,0 5.4,0 8.1,0c1.3,2.4 3.1,4.6 5.1,6c0.1,0.3 0.4,0.5 0.8,0.7Z", "style": { "fillRule": "nonzero" }, "key": 1 }), React.createElement("path", { "d": "M24.1,37.9l-1.8,0c-1.3,0 -1.7,-0.4 -1.7,-1.7c0,-1.2 0,-2.3 0,-3.5c0,-0.9 0.4,-1.4 1.4,-1.4l0.7,0c0,0.3 0,0.6 0,0.9c0.2,1.9 0.7,3.9 1.4,5.7Z", "style": { "fillRule": "nonzero" }, "key": 2 }), React.createElement("path", { "d": "M9.3,37.9c-2.4,0 -4.8,0 -7.1,0c-1.1,0 -1.5,-0.4 -1.5,-1.5c0,-1.2 0,-2.4 0,-3.7c0,-1 0.4,-1.4 1.6,-1.5l14.3,0c1,0 1.5,0.4 1.5,1.5c0,1.2 0,2.5 0,3.7c0,1 -0.4,1.4 -1.4,1.4c-2.6,0.1 -5,0.1 -7.4,0.1Z", "style": { "fillRule": "nonzero" }, "key": 3 }), React.createElement("path", { "d": "M7,28.7c-1.8,0 -3.5,0 -5.3,0c-0.8,0 -1.1,-0.4 -1.1,-1.5c0,-1.2 0,-2.4 0,-3.6c0,-1.1 0.3,-1.5 1.1,-1.5c3.5,0 7.1,0 10.6,0c0.8,0 1.1,0.4 1.1,1.5c0,1.2 0,2.4 0,3.6c0,1 -0.3,1.5 -1.1,1.5c-1.7,0 -3.5,0 -5.3,0Z", "style": { "fillRule": "nonzero" }, "key": 4 }), React.createElement("path", { "d": "M24.4,22.1c-0.9,2.3 -1.4,4.5 -1.6,6.6c-1.9,0 -3.7,0 -5.6,0c-1.1,0 -1.5,-0.4 -1.5,-1.5c0,-1.2 0,-2.4 0,-3.7c0,-1 0.4,-1.5 1.6,-1.5c2.3,0.1 4.7,0.1 7.1,0.1Z", "style": { "fillRule": "nonzero" }, "key": 5 }), React.createElement("path", { "d": "M29.1,12.9c-0.5,1 -1.1,2.1 -1.7,3.1c-0.6,1 -1.2,2 -1.7,3c-0.1,0.1 -0.1,0.3 -0.2,0.4l-3.2,0c-1.3,0 -1.7,-0.4 -1.7,-1.7c0,-1.2 0,-2.3 0,-3.5c0,-0.9 0.4,-1.4 1.4,-1.4c2.4,0.1 4.7,0.1 7.1,0.1Z", "style": { "fillRule": "nonzero" }, "key": 6 }), React.createElement("path", { "d": "M9.3,19.5c-2.4,0 -4.8,0 -7.1,0c-1.1,0 -1.5,-0.4 -1.5,-1.5c0,-1.2 0,-2.4 0,-3.7c0,-1 0.4,-1.4 1.6,-1.5l14.3,0c1,0 1.5,0.4 1.5,1.5c0,1.2 0,2.5 0,3.7c0,1 -0.4,1.4 -1.4,1.4c-2.6,0.1 -5,0.1 -7.4,0.1Z", "style": { "fillRule": "nonzero" }, "key": 7 })]), React.createElement("path", { "d": "M61,27.1c-0.1,-0.4 -0.2,-0.9 -0.2,-1.3c-1.3,-6.6 -5,-12.6 -6.8,-19.1c-1.6,2.1 -2.4,4.7 -2.4,7.3c0,1.1 0.1,2.4 -0.7,3.1c-4.1,4 -9.2,-12.8 -8,-16c0,-0.1 0,-0.2 0.1,-0.2c-4.7,2.5 -6.4,8.2 -5.6,13.2c0.4,2.5 0.1,4.9 -0.2,7.4c0,0.1 0,0.2 0,0.2c0,0.2 0,0.5 -0.1,0.7c0,0.1 -0.1,0.2 -0.1,0.3l0.1,0c-0.1,0.5 -0.2,1 -0.4,1.4c0,0 -0.1,0.1 -0.1,0.2c-0.1,0.3 -0.3,0.6 -0.5,0.9l-0.1,0.1c0,0.1 -0.1,0.1 -0.1,0.1c-0.2,0.3 -0.3,0.5 -0.6,0.7c0,0 -0.1,0.1 -0.2,0.1c-2.1,0.7 -1,-3.9 -0.8,-4.8c0.2,-1.4 0.4,-2.8 0.5,-4.3c0,-0.7 0.1,-1.5 0,-2.2c-0.1,-2.5 -2.4,-5.7 -2.4,-5.1c-0.1,3.6 -2.7,6.9 -4.2,10c-1.8,3.7 -3.3,8.2 -3,12.3c0.3,4.5 2.9,9.8 6.6,12.5c1.2,0.8 2.4,1.5 3.8,2.1c0.1,0 0.2,0.1 0.2,0.1l0.2,0c-1.4,-1.3 -1.3,-4.2 -1.3,-5.8c0.1,-3.1 1,-6.3 3,-8.8c1.3,-1.6 3.1,-3 4.7,-4.4c0.5,-0.4 0.9,-0.9 1.3,-1.3c0.1,-0.1 0.1,-0.1 0.2,-0.2c1.2,-1.4 2.2,-2.9 2.7,-5.1c0.1,-0.7 1.9,3.3 1.5,6.1c-0.4,2.5 -1.2,4.7 -2,6.9c-0.3,0.9 -2.5,5.7 -0.1,5.3c0.4,-0.1 0.8,-0.4 1.1,-0.7c0.8,-0.8 1.4,-1.8 1.8,-2.9c0.4,-1 1.7,-1.3 2.4,-0.5c0.1,0.2 0.3,0.3 0.4,0.5c0.8,1 1.3,2.2 1.6,3.4c0.4,1.5 0.4,3 0,4.5c-0.2,0.7 -0.4,1.4 -0.7,2c0.4,-0.2 0.8,-0.4 1.2,-0.6c0.3,-0.2 0.6,-0.3 0.9,-0.5c6.3,-3.7 7.4,-10.8 6.3,-17.6Z", "style": { "fillRule": "nonzero" }, "key": 1 })]))]);
	}
	
	Firewall.defaultProps = { "width": "100%", "height": "100%", "viewBox": "0 0 61 47", "version": "1.1", "xmlSpace": "preserve", "style": { "fillRule": "evenodd", "clipRule": "evenodd", "strokeLinejoin": "round", "strokeMiterlimit": "1.41421" } };
	
	module.exports = Firewall;
	
	Firewall.default = Firewall;

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Globe(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z" }));
	}
	
	Globe.defaultProps = { "viewBox": "0 0 496 512" };
	
	module.exports = Globe;
	
	Globe.default = Globe;

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Handshake(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z" }));
	}
	
	Handshake.defaultProps = { "viewBox": "0 0 640 512" };
	
	module.exports = Handshake;
	
	Handshake.default = Handshake;

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Networking(props) {
	    return React.createElement("svg", props, [React.createElement("rect", { "id": "Artboard1", "x": "0", "y": "0", "width": "80", "height": "68", "style": { "fill": "none" }, "key": 0 }), React.createElement("g", { "key": 1 }, [React.createElement("rect", { "x": "30", "y": "54", "width": "20", "height": "14", "key": 0 }), React.createElement("rect", { "x": "30", "y": "0", "width": "20", "height": "14", "key": 1 }), React.createElement("rect", { "x": "0", "y": "54", "width": "20", "height": "14", "key": 2 }), React.createElement("rect", { "x": "60", "y": "54", "width": "20", "height": "14", "key": 3 }), React.createElement("path", { "d": "M42,32l0,-14l-4,0l0,14l-30,0l0,18l4,0l0,-14l26,0l0,14l4,0l0,-14l26,0l0,14l4,0l0,-18l-30,0Z", "style": { "fillRule": "nonzero" }, "key": 4 })])]);
	}
	
	Networking.defaultProps = { "width": "100%", "height": "100%", "viewBox": "0 0 80 68", "version": "1.1", "xmlSpace": "preserve", "style": { "fillRule": "evenodd", "clipRule": "evenodd", "strokeLinejoin": "round", "strokeMiterlimit": "1.41421" } };
	
	module.exports = Networking;
	
	Networking.default = Networking;

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Workstations(props) {
	    return React.createElement("svg", props, [React.createElement("g", { "clipPath": "url(#clip0_571_695)", "key": 0 }, [React.createElement("path", { "d": "M668.738 486.827C664.259 479.358 657.54 474.879 650.072 474.879H623.936V137.385C623.936 112 603.029 91.8387 578.389 91.8387H502.977C470.868 36.588 408.898 0 337.217 0C265.536 0 203.564 37.3333 171.457 91.8387H96.045C70.6597 91.8387 50.4983 112.745 50.4983 137.385V474.879H23.6183C16.1495 474.879 9.43033 479.358 4.95166 486.827C-1.02234 497.28 -2.51715 514.452 5.69644 527.895C5.69644 528.639 6.44123 529.389 7.19124 529.389C55.7219 580.911 58.7126 580.911 63.9366 580.911H610.497C615.726 580.911 617.965 580.911 667.242 529.389L668.737 527.895C676.2 514.452 674.711 497.28 668.737 486.827H668.738ZM337.218 20.9065C429.806 20.9065 505.965 91.0945 505.965 177.707C505.965 238.936 467.137 294.936 407.402 320.32C394.71 325.549 386.496 338.241 386.496 351.68V379.305C386.496 381.545 385.001 383.04 382.761 383.04H367.829L367.834 335.253C367.834 329.279 363.355 324.8 357.381 324.8C351.407 324.8 346.928 329.279 346.928 335.253V383.04H328.262V335.253C328.262 329.279 323.782 324.8 317.809 324.8C311.835 324.8 307.356 329.279 307.356 335.253V383.04H292.424C290.184 383.04 288.689 381.545 288.689 379.305V351.68C288.689 337.492 280.476 325.544 267.782 320.32C208.048 294.935 169.22 238.935 169.22 177.707C168.475 91.0919 244.632 20.9065 337.22 20.9065H337.218ZM71.405 137.385C71.405 123.948 82.6029 112.745 96.045 112.745H161.004C152.79 132.907 148.311 154.557 148.311 177.704C148.311 247.141 192.363 310.611 259.566 339.731C264.795 341.97 267.779 346.449 267.779 351.678V379.304C267.779 392.741 278.977 403.944 292.419 403.944H383.513C396.95 403.944 408.153 392.746 408.153 379.304V351.678C408.153 346.449 411.137 341.225 416.366 339.731C484.314 310.611 527.621 247.143 527.621 177.704C527.621 154.559 523.142 132.901 514.928 112.745H579.887C593.324 112.745 604.527 123.943 604.527 137.385V474.879H71.4069L71.405 137.385ZM396.952 495.785V505.494C396.952 512.212 391.722 517.441 385.004 517.441L288.686 517.436C281.968 517.436 276.739 512.207 276.739 505.488V495.78L396.952 495.785ZM650.818 515.947C633.646 534.613 614.23 554.775 607.512 559.999H66.925C60.2062 554.025 40.789 533.863 23.6183 515.947C19.8839 509.228 22.1235 498.775 24.3631 495.785H255.83V505.494C255.83 523.415 270.762 538.348 288.684 538.348H385.002C402.923 538.348 417.856 523.416 417.856 505.494V495.785H649.323C652.308 498.77 654.547 508.478 650.813 515.947H650.818Z", "fill": "black", "key": 0 }), React.createElement("path", { "d": "M220.738 142.613C218.499 140.374 216.259 139.629 213.269 139.629C210.285 139.629 208.04 140.374 205.801 142.613C192.363 156.051 184.894 173.973 184.894 193.384C184.894 212.796 192.363 230.717 205.801 244.155C219.989 258.343 237.905 265.061 256.571 265.061C275.238 265.061 293.159 258.343 307.342 244.155C311.821 239.675 311.821 233.702 307.342 229.223L220.738 142.613ZM256.577 243.411C243.14 243.411 230.441 238.181 220.738 228.479C211.03 218.77 205.806 206.077 205.806 192.64C205.806 182.932 208.791 173.228 214.02 165.015L283.457 234.452C275.988 240.426 266.285 243.411 256.577 243.411Z", "fill": "black", "key": 1 }), React.createElement("path", { "d": "M461.165 139.627C458.181 139.627 455.936 140.371 453.696 142.611L367.082 228.48C363.347 232.215 363.347 239.678 367.082 243.412C381.27 257.6 399.186 264.319 417.852 264.319C436.519 264.319 454.44 257.6 468.623 243.412C496.248 215.787 496.248 170.24 468.623 142.61C466.389 140.375 463.404 139.625 461.164 139.625L461.165 139.627ZM390.233 235.2L459.67 165.763C472.363 185.175 470.123 211.309 452.952 228.481C436.525 245.653 410.389 247.893 390.233 235.2Z", "fill": "black", "key": 2 }), React.createElement("path", { "d": "M296.898 100.8C296.898 123.945 314.82 143.363 337.216 143.363C347.669 143.363 356.628 153.071 356.628 164.269C356.628 176.217 347.669 185.176 337.216 185.176C326.762 185.176 317.804 175.468 317.804 164.269C317.804 158.295 313.324 153.816 307.351 153.816C301.377 153.816 296.898 158.295 296.898 164.269C296.898 183.681 309.59 200.108 326.762 205.337V207.577C326.762 213.551 331.241 218.03 337.215 218.03C343.188 218.03 347.668 213.551 347.668 207.577V205.337C364.84 200.858 377.532 183.687 377.532 164.269C377.532 141.124 359.61 121.707 337.214 121.707C326.761 121.707 317.802 111.998 317.802 100.8C317.802 89.6021 326.761 79.8933 337.214 79.8933C347.668 79.8933 356.626 89.6016 356.626 100.8C356.626 106.774 361.106 111.253 367.079 111.253C373.053 111.253 377.532 106.774 377.532 100.8C377.532 81.388 364.84 64.9613 347.668 59.732V57.4924C347.668 51.5184 343.189 47.0393 337.215 47.0393C331.242 47.0393 326.762 51.5185 326.762 57.4924V59.732C309.59 64.2112 296.898 80.6386 296.898 100.8Z", "fill": "black", "key": 3 })]), React.createElement("defs", { "key": 1 }, React.createElement("clipPath", { "id": "clip0_571_695" }, React.createElement("rect", { "width": "674", "height": "581", "fill": "white" })))]);
	}
	
	Workstations.defaultProps = { "width": "674", "height": "581", "viewBox": "0 0 674 581", "fill": "none" };
	
	module.exports = Workstations;
	
	Workstations.default = Workstations;

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Workstations(props) {
	    return React.createElement("svg", props, [React.createElement("g", { "clipPath": "url(#clip0_472_652)", "key": 0 }, [React.createElement("path", { "d": "M298.365 219.735C298.365 234.856 286.922 247.119 272.811 247.119C258.697 247.119 247.257 234.856 247.257 219.735C247.257 204.609 258.697 192.35 272.811 192.35C286.922 192.35 298.365 204.609 298.365 219.735Z", "fill": "black", "key": 0 }), React.createElement("path", { "d": "M128 55.4233C130.26 55.4233 132.424 54.4605 134.025 52.7489C135.622 51.0374 136.517 48.7146 136.517 46.2924V13.5586L97.4544 55.4233H128Z", "fill": "black", "key": 1 }), React.createElement("path", { "d": "M272.811 64.5503C259.26 64.5656 246.266 70.3383 236.686 80.6076C227.103 90.877 221.713 104.798 221.702 119.32V137.578H323.92V119.32C323.906 104.798 318.515 90.877 308.936 80.6076C299.353 70.3383 286.362 64.5659 272.811 64.5503Z", "fill": "black", "key": 2 }), React.createElement("path", { "d": "M502.8 247.12H443.171V9.78042C443.171 7.35822 442.276 5.03921 440.679 3.32384C439.078 1.61228 436.914 0.65332 434.654 0.65332H153.556V46.2922C153.535 53.5511 150.836 60.504 146.048 65.6348C141.26 70.7656 134.772 73.6577 128.002 73.6768H85.4103V247.121H8.74716C4.04488 247.121 0.230255 251.205 0.230255 256.248C0.230255 261.291 4.04488 265.375 8.74716 265.375H85.4103V498.147C85.4103 505.711 91.1322 511.839 98.1875 511.839C105.246 511.839 110.965 505.711 110.965 498.147V265.375H153.556V498.147C153.556 505.711 159.278 511.839 166.334 511.839C173.389 511.839 179.111 505.711 179.111 498.147V265.375H221.703V498.147C221.703 505.711 227.421 511.839 234.48 511.839C241.535 511.839 247.257 505.711 247.257 498.147V265.375H281.328V498.147C281.328 505.711 287.05 511.839 294.105 511.839C301.161 511.839 306.883 505.711 306.883 498.147V265.375H349.474V498.147C349.474 505.711 355.193 511.839 362.252 511.839C369.307 511.839 375.029 505.711 375.029 498.147V265.375H417.621L417.617 498.147C417.617 505.711 423.339 511.839 430.394 511.839C437.453 511.839 443.172 505.711 443.172 498.147V265.375H502.801C507.503 265.375 511.318 261.291 511.318 256.248C511.318 251.205 507.503 247.121 502.801 247.121L502.8 247.12ZM306.625 247.12H238.993C233.328 239.276 230.244 229.649 230.219 219.735C230.219 203.429 238.337 188.361 251.513 180.208C264.693 172.052 280.928 172.052 294.105 180.208C307.282 188.361 315.399 203.429 315.399 219.735C315.374 229.649 312.29 239.276 306.625 247.12ZM375.028 247.12H357.99V174.092C357.976 169.255 356.179 164.621 352.985 161.197C349.794 157.778 345.47 155.849 340.952 155.834H204.665C200.152 155.849 195.828 157.778 192.633 161.197C189.442 164.621 187.642 169.255 187.628 174.092V247.12H170.594V174.092C170.594 164.407 174.184 155.12 180.573 148.274C186.962 141.428 195.628 137.58 204.665 137.58V119.322C204.665 93.232 217.652 69.1255 238.736 56.0785C259.821 43.0355 285.798 43.0355 306.883 56.0785C327.967 69.1255 340.954 93.232 340.954 119.322V137.58C349.991 137.58 358.658 141.427 365.046 148.274C371.438 155.12 375.029 164.407 375.029 174.092L375.028 247.12Z", "fill": "black", "key": 3 })]), React.createElement("defs", { "key": 1 }, React.createElement("clipPath", { "id": "clip0_472_652" }, React.createElement("rect", { "width": "512", "height": "512", "fill": "white" })))]);
	}
	
	Workstations.defaultProps = { "width": "512", "height": "512", "viewBox": "0 0 512 512", "fill": "none" };
	
	module.exports = Workstations;
	
	Workstations.default = Workstations;

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Server(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z" }));
	}
	
	Server.defaultProps = { "viewBox": "0 0 512 512" };
	
	module.exports = Server;
	
	Server.default = Server;

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Virtualization(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M537.585 226.56C541.725 215.836 544 204.184 544 192c0-53.019-42.981-96-96-96-19.729 0-38.065 5.954-53.316 16.159C367.042 64.248 315.288 32 256 32c-88.366 0-160 71.634-160 160 0 2.728.07 5.439.204 8.133C40.171 219.845 0 273.227 0 336c0 79.529 64.471 144 144 144h368c70.692 0 128-57.308 128-128 0-61.93-43.983-113.586-102.415-125.44z" }));
	}
	
	Virtualization.defaultProps = { "viewBox": "0 0 640 512" };
	
	module.exports = Virtualization;
	
	Virtualization.default = Virtualization;

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Workstations(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z" }));
	}
	
	Workstations.defaultProps = { "viewBox": "0 0 576 512" };
	
	module.exports = Workstations;
	
	Workstations.default = Workstations;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-solutions-js-d498b58597f0327297fd.js